import {type MRT_Localization, type MRT_RowData, type MRT_TableOptions} from "material-react-table";

export const getDefaultMRTOptions = <TData extends MRT_RowData>(
    locale: MRT_Localization,
): Partial<MRT_TableOptions<TData>> => {
    return {
        initialState: {
            showColumnFilters: true,
            pagination: {
                pageIndex: 0,
                pageSize: 15,
            },
        },
        enableTopToolbar: false,
        enableDensityToggle: false,
        enableRowActions: true,
        enableColumnActions: false,
        enableToolbarInternalActions: false,
        enableColumnResizing: false,
        positionActionsColumn: "last",
        enableFilters: true,
        muiTablePaperProps: {
            elevation: 0,
        },
        muiFilterTextFieldProps: {
            variant: "filled",
            InputProps: {
                disableUnderline: true,
                size: "small",
                sx: {
                    fontSize: "14px",
                },
            },
            sx: {
                marginTop: "0.25rem",
            },
        },
        muiTableHeadCellProps: {
            sx: {
                bgcolor: "#F3F5FA",
                paddingBottom: "1rem",
                "& .Mui-TableHeadCell-Content-Labels": {
                    textTransform: "uppercase",
                    fontWeight: "500",
                },
            },
        },
        muiCircularProgressProps: {
            color: "primary",
            size: 55,
        },
        localization: locale,
    };
};
